import { useContext, useEffect, useState } from "react";
import { EditorContext } from "./../../ricos-context";
const useEditorSelection = (editor) => {
  const { getPublicCommands } = useContext(EditorContext);
  const [selection, setSelection] = useState(
    () => getPublicCommands().getSelection()
  );
  useEffect(() => {
    const onSelectionUpdate = () => {
      setSelection(getPublicCommands().getSelection());
    };
    editor.on("selectionUpdate", onSelectionUpdate);
    return () => {
      editor.off("selectionUpdate", onSelectionUpdate);
    };
  }, []);
  return selection;
};
export {
  useEditorSelection
};
//# sourceMappingURL=use-editor-selection.js.map
